import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { getAuth } from 'firebase/auth';
import { firebaseConfig, db } from './firebase'; 
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

firebase.initializeApp(firebaseConfig);

const AddTaskPopup = ({ addTask }) => {
  const [newTask, setNewTask] = useState('');
  const [newTag, setNewTag] = useState('');
  const [newPriority, setNewPriority] = useState('Low');
  const [newNotes, setNewNotes] = useState('');
  const [tasks, setTasks] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false); 


  useEffect(() => {
    const fetchTasks = async () => {
      try {
        const auth = getAuth();
        const user = auth.currentUser;
        let tasks = [];
        
        if (user) {
          const snapshot = await db.collection('tasks')
            .where('deleted', '==', false)
            .where('userId', '==', user.uid)
            .get();
          tasks = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        } else {
          const storedTasks = sessionStorage.getItem('tasks');
          if (storedTasks) {
            tasks = JSON.parse(storedTasks);
          }
        }
        
        setTasks(tasks);
      } catch (error) {
        console.error(error);
      }
    };
  
    fetchTasks();
  }, [db]);

  const handleSubmit = async (event) => {
    console.log('Adding task...');
    event.preventDefault();
    if (newTask.trim()) {
      const auth = getAuth();
      const user = auth.currentUser;
      const task = {
        name: newTask,
        tag: newTag,
        priority: newPriority,
        notes: newNotes,
        completed: false,
        deleted: false,
        userId: user ? user.uid : null, 
      };
      
      if (user) {
        try {
          const docRef = await db.collection('tasks').add(task);
          console.log('Task added successfully');
          setTasks(prevTasks => [...prevTasks, { id: docRef.id, ...task }]);
          addTask(task);
        } catch (error) {
          console.error('Error adding task:', error);
        }
      } else {
        const updatedTasks = [...tasks, task];
        setTasks(updatedTasks);
        sessionStorage.setItem('tasks', JSON.stringify(updatedTasks));
        addTask(task); 
      }
      
      setNewTask('');
      setNewTag('');
      setNewPriority('Low');
      setNewNotes('');
    }
    setModalIsOpen(false); 
  };

  return (
    <div className='modalScreen'>
        <button onClick={() => setModalIsOpen(true)}>+</button> 
          <Modal isOpen={modalIsOpen} onRequestClose={() => setModalIsOpen(false)}
              style={{ content: {
                  width: '30%', 
                  height: '45%', 
                  margin: 'auto', 
                  backgroundColor: 'whitesmoke',
                  borderColor: 'lightgrey',
                },
              }}> 
            <form className='modalForm' onSubmit={handleSubmit}>
              <h2>Add New Task</h2>
                <input className='modalinput'
                  type="text"
                  placeholder="Task"
                  value={newTask}
                  onChange={event => setNewTask(event.target.value)}
                />
                <input className='modalinput'
                  type="text"
                  placeholder="Tag"
                  value={newTag}
                  onChange={event => setNewTag(event.target.value)}
                />
                <select className='modalinput'
                  value={newPriority}
                  onChange={event => setNewPriority(event.target.value)}
                >
                  <option value="Low">Low</option>
                  <option value="Medium">Medium</option>
                  <option value="High">High</option>
                </select>
                <input className='modalinput'
                  placeholder="Notes"
                  value={newNotes}
                  onChange={event => setNewNotes(event.target.value)}
                />
                <button className='modalinput' onClick={handleSubmit}>Add Task</button>
            </form>
          </Modal>
    </div>
  );
};

export default AddTaskPopup;
